var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.138,
    height: 42,
    viewBox: "0 0 42.138 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_User_310629",
    transform: "translate(-0.7 -0.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20",
    "data-name": "Grupo 20",
    transform: "translate(0.7 0.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17",
    "data-name": "Grupo 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1053",
    "data-name": "Trazado 1053",
    d: "M38.982,32.748h0a.755.755,0,0,1-.826-.551,19.2,19.2,0,0,0-16.387-9.5A18.911,18.911,0,0,0,5.382,32.2a1.034,1.034,0,0,1-1.79,0A21.753,21.753,0,0,1,.7,21.731a21.069,21.069,0,0,1,42.138,0A19.976,19.976,0,0,1,39.946,32.2.922.922,0,0,1,38.982,32.748ZM21.769,20.767a21.335,21.335,0,0,1,17.213,8.951,19.885,19.885,0,0,0,1.79-7.987,18.935,18.935,0,1,0-37.869,0,18.247,18.247,0,0,0,1.79,7.987A20.539,20.539,0,0,1,21.769,20.767Z",
    transform: "translate(-0.7 -0.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18",
    "data-name": "Grupo 18",
    transform: "translate(2.789 19.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1054",
    "data-name": "Trazado 1054",
    d: "M21.005,37.333A21.046,21.046,0,0,1,2.828,26.867a1.508,1.508,0,0,1,0-1.1,21.018,21.018,0,0,1,36.354,0,1.508,1.508,0,0,1,0,1.1A21.343,21.343,0,0,1,21.005,37.333ZM4.894,26.316a19.014,19.014,0,0,0,16.111,8.951,19.191,19.191,0,0,0,16.111-8.951,18.976,18.976,0,0,0-32.223,0Z",
    transform: "translate(-2.725 -15.3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19",
    "data-name": "Grupo 19",
    transform: "translate(14.046 4.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1055",
    "data-name": "Trazado 1055",
    d: "M17.923,18.046a7.023,7.023,0,1,1,7.023-7.023A7.053,7.053,0,0,1,17.923,18.046Zm0-12.118a4.957,4.957,0,1,0,4.957,4.957A4.937,4.937,0,0,0,17.923,5.928Z",
    transform: "translate(-10.9 -4)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserTop);
export default __webpack_public_path__ + "static/media/user-top.6d006db4b31d448df8a7de5c45a1d018.svg";
export { ForwardRef as ReactComponent };